import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { Divider } from "@cars24/turbo-web/lib/divider";
import { Label } from "@cars24/turbo-web/lib/label";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import RtoInfoRegNo from "../rto-info-reg-no";
import { NUMBER } from "../../../constants/app-constants";
import RtoBanner from  "./images/rto-banner.jpg";
import StarIcon from  "./images/star.svg";
import styles from "./styles.css";

const RtoVehInfoBanner = ({
    cms,
    jsonContent,
    isSSR,
    canonical,
    updateSSRStatusConnect,
    getSeoContentConnect
}) => {
    const { tokens } = useTokens();
    const fontColor = tokens.text_default_text_inverse;
    const { header } = jsonContent || {};
    const { title = "", itemList = [] } = header || {};

    useEffect(() => {
        updateSSRStatusConnect(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSSR && !title) {
            const cmsPayload = {
                cmsuri: canonical,
                expand: "seo_content"
            };
            getSeoContentConnect(cmsPayload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    const {
        h1: heading
    } = cms || {};

    return (
        <div styleName={"styles.rtoBanner"}>
            <img src={RtoBanner} alt="rto banner" styleName={"styles.banner"} />
            <div styleName={"styles.bannerText"}>
                <div styleName={"styles.textWrapper"}>
                    <Heading level={1} isBold={true} color={tokens.text_default_text_inverse}>{heading}</Heading>
                    <div styleName={"styles.divider"}>
                        <Divider />
                    </div>
                    <Label level={NUMBER.ONE} color={fontColor} fontWeight={"semibold"}>{title}</Label>
                    <ul>
                        {
                            itemList.map((item, index) => {
                                return (
                                    <li key={`rto-item-${index}`}>
                                        <BodyText level={NUMBER.TWO} color={fontColor}>
                                            <img src={StarIcon} alt="star" />
                                            {item.title}
                                        </BodyText>
                                    </li>
                                );
                            })
                        }
                    </ul>

                </div>
                <div styleName={"styles.rtoRegNo"}>
                    <RtoInfoRegNo isRevamped={true}/>
                </div>
            </div>
        </div>
    );
};

RtoVehInfoBanner.propTypes = {
    cms: PropTypes.object,
    jsonContent: PropTypes.object,
    isSSR: PropTypes.bool,
    canonical: PropTypes.string,
    updateSSRStatusConnect: PropTypes.func,
    getSeoContentConnect: PropTypes.func
};

export default RtoVehInfoBanner;
